/* eslint react/prop-types: off */
import React, { useState } from 'react'
import {
  Col,
  FormInput,
  FormInputSelect,
  FormInputText,
  Row
} from 'camino-react'

const Form = ({
  clients,
  priorities,
  clientSLA: {
    client_id: clientID,
    priority_id: priorityID
  },
  targetResponse: {
    hours: currentHours = 0,
    minutes: currentMinutes = 0
  },
  targetResolution: targetResolutionProps
}) => {
  const clientOptions = clients.map(client => (
    { value: client.id, label: client.full_name }
  ))

  const priorityOptions = priorities.map(priority => (
    { value: priority.id, label: priority.name }
  ))

  const selectValue = (options, value) => (
    value ? options.find(option => option.value === value) : {}
  )

  const [client, setClient] = useState(selectValue(clientOptions, clientID))
  const [priority, setPriority] = useState(selectValue(priorityOptions, priorityID))
  const [hours, setHours] = useState(currentHours)
  const [minutes, setMinutes] = useState(currentMinutes)
  const [targetResolution, setTargetResolution] = useState(targetResolutionProps)

  return (
    <>
      <FormInput label="Client">
        <FormInputSelect
          options={clientOptions}
          value={client}
          onValue={value => setClient(selectValue(clientOptions, value))}
        />
      </FormInput>

      <FormInput label="Priority">
        <FormInputSelect
          options={priorityOptions}
          value={priority}
          onValue={value => setPriority(selectValue(priorityOptions, value))}
        />
      </FormInput>

      <FormInput label="Target Response">
        <Row>
          <Col>
            <FormInput label="Hours">
              <FormInputText
                value={hours}
                onValue={value => setHours(value)}
                type="number"
              />
            </FormInput>
          </Col>

          <Col>
            <FormInput label="Minutes">
              <FormInputText
                value={minutes}
                onValue={value => setMinutes(value)}
                type="number"
              />
            </FormInput>
          </Col>
        </Row>
      </FormInput>

      <FormInput label="Target Resolution">
        <Row>
          <Col>
            <FormInput label="Hours">
              <FormInputText
                value={targetResolution.hours}
                onValue={value => setTargetResolution({ ...targetResolution, hours: value })}
                type="number"
              />
            </FormInput>
          </Col>

          <Col>
            <FormInput label="Minutes">
              <FormInputText
                value={targetResolution.minutes}
                onValue={value => setTargetResolution({ ...targetResolution, minutes: value })}
                type="number"
              />
            </FormInput>
          </Col>
        </Row>
      </FormInput>

      <input type="hidden" name="clients_priority[client_id]" value={client.value} />
      <input type="hidden" name="clients_priority[priority_id]" value={priority.value} />
      <input type="hidden" name="clients_priority[target_response_hours]" value={hours} />
      <input type="hidden" name="clients_priority[target_response_minutes]" value={minutes} />
      <input type="hidden" name="clients_priority[target_resolution_hours]" value={targetResolution.hours} />
      <input type="hidden" name="clients_priority[target_resolution_minutes]" value={targetResolution.minutes} />
    </>
  )
}

export default Form
